// Axios
import axios from 'axios';

export async function getJsonData(url: string) {
  try {
    const response = await axios.get(url, { responseType: 'json' });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    // Nothing!
  }

  return null;
}
